import React, {useState} from 'react'
import ReactDOM from 'react-dom'

const Description = ({text, length}) => {
    const [readMore, setReadMore] = React.useState(false);

    if (text.length < length) {
        return <p>{text}</p>;
    }
    // Bootstrap classes
    let classes = `col-12 text-padding align-left`;

    return (
        <div className={classes}>
            <span>{readMore ? text : `${text.slice(0, length - 3)}... `}
                {/*<br/>*/}
                {/*<div className={"read-more"}>*/}
                <a className={"read-more"} onClick={() => {
                    setReadMore(!readMore)
                }}>
                    {readMore ? " Mažiau" : " Daugiau"}
                </a>
                {/*</div>*/}
            </span>

        </div>
    );
};
const text1 =
    "Kognityvinė ir elgesio terapija – tai trumpalaikė terapija, orientuota į konkrečių sunkumų sprendimą " +
    "ar patiriamų simptomų lengvinimą. Ši terapija dažnai yra pirmo pasirinkimo priemonė gydant depresiją " +
    "ir nerimo sutrikimus, bei gali padėti spręsti lėtinio streso, nemigos, žemos savivertės, " +
    "atidėliojimo, santykių ir kitas problemas. Kognityvinė ir elgesio terapija yra grindžiama " +
    "prielaida, jog mūsų mintys, jausmai ir elgesys yra tarpusavyje susiję. Taigi, keičiant tam tikrus " +
    "mąstymo ar elgesio įpročius, keičiasi ir savijauta. Terapijos metu pirmiausia siekiame pastebėti " +
    "ir atpažinti mintis ar veiksmus, kurie galėtų palaikyti problemą. Kalbėdamiesi bei pasitelkdami " +
    "įvairias technikas ir pratimus, ieškome alternatyvių požiūrių ir mokomės naujų, vertingų įgūdžių, " +
    "padedančių spręsti patiriamus sunkumus bei įgalinančių savarankiškai įveikti ateityje laukiančius iššūkius.  ";

const text2 =
    "Schemų terapija – tai ilgalaikė terapija, orientuota į gilesnį asmenybės pažinimą ir ilgalaikių " +
    "sunkumų sprendimą. Šioje terapijoje persipina vertingiausios kognityvinės ir elgesio, " +
    "psichodinaminės, Geštalto ir kitų terapinių krypčių idėjos bei technikos, ji pasižymi šiltu ir " +
    "empatišku kliento ir terapeuto santykiu, noru suprasti gilumines problemų priežastis bei siekiu " +
    "įgyti naują emocinį patyrimą ir keisti mąstymo ar elgesio įpročius, kurie palaiko sunkumus. " +
    "Esminė schemų terapijos idėja teigia, jog mes visi turime įgimtus emocinius poreikius. " +
    "Mums svarbu jausti, kad mus myli, saugo, vertina. Kai vaikystėje ar paauglystėje šie poreikiai " +
    "nėra pakankamai atliepiami, gali susiformuoti „schema“ – tam tikrų minčių, jausmų, prisiminimų ir " +
    "kūno pojūčių rinkinys, lydintis mus per gyvenimą ir sukeliantis pasikartojančias problemas." +
    "Schemų terapijos metu kartu stengiamės suprasti, kurios schemos žmogui būdingos ir kaip jos galėjo susiformuoti. " +
    "Tyrinėjame, kaip jos veikia gyvenimą, savijautą, santykius, pasirinkimus. Ieškome būdų, kurie padėtų " +
    "atliepti vidinius emocinius poreikius ir leistų schemoms gyti, o žmogui – tapti laimingesne ir stipresne asmenybe.  ";

document.addEventListener('turbolinks:load', () => {
    if (document.getElementById("proc-desc")) {
        ReactDOM.render(
            <React.Fragment>
                <Description text={text1} length={324}/>
                <Description text={text2} length={334}/>
            </React.Fragment>,
            document.getElementById("proc-desc")
        )
    }
})